enum ActivityTaskType { // this is also Node.StepType
  TASK = 0,
  CUSTOM_EMAIL = 6,
  APPROVAL = 8,
  PARALLEL_APPROVAL = 9,
  SEQUENTIAL_APPROVAL = 10,
  COMPONENT = 11,
  EXTERNAL_USER_TASK = 12,
  PUBLIC_FORM = 99
}

export default ActivityTaskType;
